import React from 'react';
import { FiFacebook, FiInstagram, FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-arcdom-navy text-white pt-16 pb-8">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-2xl font-bold text-arcdom-gold mb-6">ARCDOM</h3>
                        <p className="mb-6 text-gray-300">
                            Building quality homes and spaces since 2007. With a focus on excellence,
                            innovation, and customer satisfaction.
                        </p>
                        <div className="flex space-x-4">
                            <a
                                href="https://www.facebook.com/arcdom.ro"
                                className="text-white hover:text-arcdom-gold transition-colors duration-300"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FiFacebook size={20}/>
                            </a>
                            <a
                                href="https://www.instagram.com/arcdomresidence"
                                className="text-white hover:text-arcdom-gold transition-colors duration-300"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FiInstagram size={20}/>
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
                        <ul className="space-y-3">
                            <li>
                                <a href="#services"
                                   className="text-gray-300 hover:text-arcdom-gold transition-colors duration-300">
                                    Our Services
                                </a>
                            </li>
                            <li>
                                <a href="#projects" className="text-gray-300 hover:text-arcdom-gold transition-colors duration-300">
                                    Projects
                                </a>
                            </li>
                            <li>
                                <a href="#room-types" className="text-gray-300 hover:text-arcdom-gold transition-colors duration-300">
                                    Property Types
                                </a>
                            </li>
                            <li>
                                <a href="#construction" className="text-gray-300 hover:text-arcdom-gold transition-colors duration-300">
                                    Construction Quality
                                </a>
                            </li>
                            <li>
                                <a href="#faq" className="text-gray-300 hover:text-arcdom-gold transition-colors duration-300">
                                    FAQ
                                </a>
                            </li>
                            <li>
                                <a href="#contact" className="text-gray-300 hover:text-arcdom-gold transition-colors duration-300">
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6">Contact Information</h4>
                        <ul className="space-y-3">
                            <li className="flex items-start">
                                <FiMapPin className="text-arcdom-gold mt-1 mr-3" />
                                <span className="text-gray-300">
                  Str. Somesului 2 D Sc. 3 Ap. 3, Florești, Romania
                </span>
                            </li>
                            <li className="flex items-start">
                                <FiPhone className="text-arcdom-gold mt-1 mr-3" />
                                <span className="text-gray-300">
                  (0754) 041 648
                </span>
                            </li>
                            <li className="flex items-start">
                                <FiMail className="text-arcdom-gold mt-1 mr-3" />
                                <span className="text-gray-300">
                  office@arcdom.ro
                </span>
                            </li>
                        </ul>
                    </div>

                    {/* Business Hours */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6">Business Hours</h4>
                        <ul className="space-y-3">
                            <li className="text-gray-300">
                                <span className="font-medium">Monday - Friday:</span>
                                <br />
                                9:00 AM - 6:00 PM
                            </li>
                            <li className="text-gray-300">
                                <span className="font-medium">Saturday:</span>
                                <br />
                                10:00 AM - 2:00 PM
                            </li>
                            <li className="text-gray-300">
                                <span className="font-medium">Sunday:</span>
                                <br />
                                Closed
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-700 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400 text-sm mb-4 md:mb-0">
                            &copy; {currentYear} Arcdom. All rights reserved.
                        </p>
                        <div className="flex space-x-8 mr-12">
                            <Link
                                to="/privacy-policy" // Use the path defined in App.js
                                className="text-gray-400 hover:text-arcdom-gold text-sm transition-colors duration-300"
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                to="/terms-of-service" // Use the path defined in App.js
                                className="text-gray-400 hover:text-arcdom-gold text-sm transition-colors duration-300"
                            >
                                Terms of Service
                            </Link>
                            <Link
                                to="/cookie-policy" // Use the path defined in App.js
                                className="text-gray-400 hover:text-arcdom-gold text-sm transition-colors duration-300"
                            >
                                Cookies Policy
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
